import Login from '@/views/Login.vue';

export default [
  // routes
  {
    name: 'change-password',
    path: '/alterar-senha',
    component: () => import('@/views/AlterPassword.vue'),
  },
  {
    name: 'login',
    path: '/',
    component: Login,
  },
  {
    name: 'recover-password',
    path: '/recuperar-senha',
    component: Login,
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    name: 'reports',
    path: '/relatorios',
    component: () => import('@/views/Reports.vue'),
  },
  {
    name: 'edit-user',
    path: '/configuracao',
    component: () => import('@/views/EditUser.vue'),
  },
  {
    name: 'cache-config',
    path: '/cache',
    component: () => import('@/views/CacheView.vue'),
  },
  {
    name: 'referral-links',
    path: '/referral-links',
    component: () => import('@/views/ReferralLinks.vue'),
  },
  {
    name: 'bonds-details',
    path: '/indicadas',
    component: () => import('@/views/BondsDetails.vue'),
  },
  {
    name: 'limits-consult',
    path: '/limites-consulta',
    component: () => import('@/views/LimitsView.vue'),
  },
  {
    name: 'terms',
    path: '/termos-de-uso',
    component: () => import('@/views/TermsView.vue'),
  },
  {
    name: 'guidelines',
    path: '/roteiros',
    component: () => import('@/views/GuidelinesView.vue'),
  },
  {
    name: 'collabs',
    path: '/colaboradores',
    component: () => import('@/views/CollabList.vue'),
  },

  // redirects (legacy)
  {
    path: '/usuarios/editar',
    redirect: '/configuracao',
  },
];
